import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuBoolean',
    props: {
        filter: { type: Object, required: true },
        name: { type: String, required: true },
        filters: { type: Object, required: true },
    },
    emits: ["change", "on-enter", "on-esc"],
    setup(__props, { emit }) {
        const props = __props;
        const boolType = computed(() => props.filter.boolType || "default");
        const options = boolType.value == "default"
            ? [
                { text: "Any", value: "any" },
                { text: "Yes", value: true },
                { text: "No", value: false },
            ]
            : [
                { text: "Yes", value: true },
                { text: "No", value: "any" },
            ];
        const value = computed({
            get: () => {
                const value = props.filters[props.name];
                return value !== undefined ? value : "any";
            },
            set: (newVal) => {
                const value = newVal !== null ? newVal : "any";
                emit("change", props.name, value);
            },
        });
        return { __sfc: true, props, boolType, options, emit, value };
    }
});
